import React from 'react';
import PropTypes from 'prop-types';
import { Link, Icon, grey600 } from '@paypalcorp/pp-react';

function SocialShareFacebook({ url, handleSocialLinkClick }) {
  return (
    <Link
      href={url}
      target="popup"
      onClick={() => handleSocialLinkClick(url, 'facebook')}
      style={{ color: grey600 }}
      data-testid="social-share-facebook"
    >
      <Icon name="share-facebook" className="ppvx_icon--size_lg" />
    </Link>
  );
}

SocialShareFacebook.propTypes = {
  url: PropTypes.string,
  handleSocialLinkClick: PropTypes.func,
};

export default SocialShareFacebook;
